<template>
  <el-upload class="uploader"
             :action="FileUploadURL"
             :show-file-list="false"
             :accept="fileType===1?'image/*':''"
             :on-success="handleSuccess"
             :before-upload="handlebeforeUpload">
    <template v-if="fileType===1">
      <img slot="trigger"
           v-if="value"
           :src="value"
           class="image" />
      <div slot="trigger"
           v-loading="loading"
           v-else
           class="info-container">
        <div>
          <i class="el-icon-plus image-uploader-icon"></i>
          <!-- <div>请上传图片</div> -->
          <slot name="nmae"><div>请上传图片</div></slot>
        </div>
      </div>
      <el-link class="image-link"
               v-if="value"
               :underline="false"
               :href="value"
               :download="value"
               target="_blank">下载图片</el-link>
    </template>
    <template v-else-if="fileType===2">
      <el-button class="button mr20"
                 slot="trigger"
                 size="mini"
                 >
                 <slot>上传</slot>
                 </el-button>
                 <template v-if="isShow">
      <el-link v-if="value"
               type="primary"
               :underline="false"
               :href="value"
               :download="value"
               target="_blank">下载上传文件</el-link>
      <el-link v-else
               type="info"
               :underline="false"
               target="_blank">未上传</el-link>
               </template>
    </template>
  </el-upload>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    value: String,
    required: true,
    fileType: { type: Number, default: 1 }, //1代表图片，2代表文档
    isShow:{ type: Boolean, default: true },
  },
  data() {
    return {
      FileUploadURL: this.$common.FileUploadURL,
      loading: false
    }
  },
  methods: {
    handleSuccess(res, file) {
      this.loading = false
      const imageUrl = res.data
      this.$emit('input', imageUrl)
      this.$emit('handleSuccess', imageUrl)
    },
    handlebeforeUpload(file) {
      this.loading = true
      // 这里做可以做文件校验操作
      let isImg = false
      if (file.type === 'image/jpeg') {
        isImg = true
      }
      if (file.type === 'image/png') {
        isImg = true
      }
      if (this.fileType === 2) {
        isImg = true
      }
      let isLt5M = file.size / 1024 / 1024 < 500
      if (!isImg) {
        this.loading = false
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt5M) {
        this.loading = false
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isImg && isLt5M
    }
  }
}
</script>

<style scoped lang="scss">
.uploader {
  width: auto;
  height: auto;
  /deep/ .el-upload {
    .info-container,
    img {
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 200px;
      height: 200px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(235, 236, 239, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        border-color: #f65248;
      }
    }
  }
  .image-link {
    width: 200px;
    display: block;
    text-align: center;
  }
}
</style>